import React from "react";
import { motion } from "framer-motion";
import { createPortal } from "react-dom";

export default function PageModal({ children }) {
  return createPortal(
    <div className="fixed top-0 right-0 w-screen bg-black backdrop-blur-sm bg-opacity-50 h-screen overflow-y-scroll z-[100] flex items-start justify-center lg:p-8 scroll-my-0 ">
      <motion.div
        className="flex items-start justify-center w-screen min-h-screen backdrop:blur-sm"
        initial={{ opacity: 0, y: 100 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: 100 }}
        transition={{ duration: 0.3 }}
      >
        {children}
      </motion.div>
    </div>,
    document.body
  );
}